"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
function findHTMLElement(e) {
    var el = ReactDOM.findDOMNode(e);
    if (el && el.focus) {
        return el;
    }
    return undefined;
}
exports.default = findHTMLElement;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-calendar-react/dist/lib/findHTMLElement.js
// module id = 1586
// module chunks = 0